export function getView(lead) {
  if (lead.patient_id) return false
  if (lead.status === 'dismissed') return 'UnDismiss'
  return 'Dismiss'
}
